<template>
  <filter-wrapper @submit="submit">
    <div class="filter__row">
      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('phone-number.stats.general.filter.group_by.title') }}
        </label>
        <div class="filter__item__body">
          <i-select v-model="form.group_by">
            <i-option
              v-for="(label, key) in $t('phone-number.stats.general.filter.group_by.value')"
              :key="key"
              :value="key"
              :label="label"
            />
          </i-select>
        </div>
      </div>

      <div class="filter__item col-3">
        <label class="filter__item__title">
          {{ $t('phone-number.stats.general.filter.country.title') }}
        </label>
        <div class="filter__item__body">
          <country-select v-model="form.country_code" :only_user_data="true" />
        </div>
      </div>

      <div class="filter__item filter__item--datepicker col-4">
        <label class="filter__item__title">
          {{ $t('shared.component.filter.period') }}
        </label>
        <div class="filter__item__body">
          <date-picker
            v-model="form.date"
            format="yyyy-MM-dd HH:mm:ss"
            :transfer="true"
            type="datetimerange"
            :placeholder="
              $t('referral.profit.field.date_from') + ' - ' + $t('referral.profit.field.date_to')
            "
            :clearable="true"
            @on-ok="reset_all_period"
            @on-clickoutside="reset_all_period"
          />
        </div>
      </div>

      <div class="filter__item col-2 filter__item--flex-end">
        <div class="flex flex-row-between">
          <div :class="{ tag: true, 'tag--selected': !!all_period }" @click="select_all_period">
            {{ $t('shared.date.all_period') }}
          </div>
        </div>
      </div>

      <div class="filter__item filter__item--button ml-auto">
        <i-button html-type="submit" type="primary" size="large">
          {{ $t('shared.component.filter.show_result') }}
        </i-button>
      </div>
    </div>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import CountrySelect from '@shared/components/input/input-country-select';
  import { mapActions } from 'vuex';
  import { getCleanJSDatePeriod, parseSearchStateByPeriod } from '@shared/helpers/date_format';

  export default {
    components: {
      FilterWrapper,
      CountrySelect
    },
    data() {
      return {
        all_period: false,
        form: {
          group_by: 'month',
          country_code: null,
          status: null,
          number: '',
          date: getCleanJSDatePeriod()
        }
      };
    },

    computed: {
      formattedDate() {
        const start = this.form.date[0] ? this.formatDate(this.form.date[0]) : '';
        const end = this.form.date[1] ? this.formatDate(this.form.date[1]) : '';
        return { start, end };
      }
    },

    mounted() {
      this.submit();
    },

    methods: {
      ...mapActions('phone-number/stats/general', ['search']),

      formatDate(date) {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        const hours = ('0' + date.getHours()).slice(-2);
        const minutes = ('0' + date.getMinutes()).slice(-2);
        const seconds = ('0' + date.getSeconds()).slice(-2);
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },

      reset_all_period() {
        // check date exist
        // if (this.form.date[0]) {
        this.all_period = !this.form.date[0];
        // }
      },

      select_all_period: function () {
        this.all_period = true;
        this.form.date = null;
      },

      submit: function () {
        const { start, end } = parseSearchStateByPeriod(this.formattedDate);

        const { group_by, country_code, status, number } = this.form;
        const params = {
          group_by,
          country_code,
          status,
          number,
          date_from: this.all_period ? null : start,
          date_to: this.all_period ? null : end
        };

        this.search(params);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .filter__item--datepicker {
    min-width: initial;
  }

  .tag {
    width: inherit;
  }
</style>
